export const bytesToKb = (bytes: number) => {
  return Math.round(bytes / 1024);
};